var inherit = require("./../general.js").inherit;
var extend = require("./../general.js").extend;
var HashMap = require("../collections/hashMap.js");
var hash = require("../hash.js");
var ObservableShadow = require("./observableShadow.js");

var ObservableCachedFunction = function(getter, sensitivityList, thisArg, size, hashType){
    ObservableShadow.call(this, getter, null, sensitivityList, thisArg);
    this.hashType = hashType;
    this._cache = null;
    this.lru_counter = 0;
    this.size = size || Number.Infinity;
};
inherit(ObservableCachedFunction, ObservableShadow);

ObservableCachedFunction.createNewFunction = function(args){
    var observableCachedFunction = function(){
        var args = Array.prototype.slice.call(arguments); //convert from arraylike object to array
        return observableCachedFunction.get(args);
    };
    extend(observableCachedFunction, this.prototype, true);
    this.apply(observableCachedFunction, arguments);

    return observableCachedFunction;
};

ObservableCachedFunction.prototype.getType = function(){return "cachedFunction";};

/**
 * The cache maps function arguments to corresponding function outputs.
 * Each cache item also stores the value of the lru counter at the time it was last accessed.
 * This allows us to find the item that was least recently when an item needs to be cleared from the cache.
 */
ObservableCachedFunction.prototype.get = function(args){
    if (!this._cache)
        this._createCache();
    if (!this._cache.contains(args)){
        this._cache.put(args, [this.getter.apply(this.thisArg, args), undefined]);
        this._keepLeastRecentlyUsed();
    }
    var res = this._cache.get(args);
    res[1] = this.lru_counter;
    this.lru_counter += 1;
    return res[0];
};

ObservableCachedFunction.prototype.set = undefined; // cachedFunction don't have setters

ObservableCachedFunction.prototype.setDirty = function(trigger){
    var self = this;
    this._cache = null; //clear cache
    this.handlers.change && this.handlers.change.forEach(function(k, handler){  // TODO: maybe change this in onTrigger handlers since you don't know anything about current or previous value yet
        handler.call(self);
    });
};

ObservableCachedFunction.prototype._keepLeastRecentlyUsed = function(){
    if(this._cache && this._cache.size() > this.size) {
        var lruArgs = null;
        var lruCounter = null;
        this._cache.forEach(function(k, v) {
            if(!lruArgs || lruCounter > v[1]) {
                lruArgs = k;
                lruCounter = v[1];
            }
        });
        this._cache.remove(lruArgs);
    }
};

ObservableCachedFunction.prototype._createCache = function() {
    if(this.hashType){
        this._cache = new HashMap(this.hashType);
    } else {
        this._cache = new HashMap(hash.arrayHash);
    }
};

module.exports = ObservableCachedFunction;
